import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage } from 'react-intl';
import { FieldRowStyled, FieldValueStyled } from '../ConnectionInspectorPage.styles';

type FieldRowProps = {
  labelId: string;
  value: React.ReactNode;
  color: string;
  navigateTo?: string;
};

export const FieldRow = ({ labelId, value, color, navigateTo }: FieldRowProps) => (
  <FieldRowStyled>
    <Typography
      sx={{
        fontSize: '0.67rem',
        fontWeight: 700,
        textTransform: 'uppercase',
        letterSpacing: '0.08em',
        color: `${color}bb`,
      }}
    >
      <FormattedMessage id={labelId} />
    </Typography>
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
      <FieldValueStyled variant="body2">{value}</FieldValueStyled>
      {navigateTo && (
        <IconButton
          size="small"
          onClick={() => window.open(navigateTo, '_blank', 'noopener,noreferrer')}
          sx={{ color, p: 0.5, opacity: 0.7, '&:hover': { opacity: 1 } }}
          aria-label="open in new tab"
        >
          <FontAwesomeIcon icon={faArrowUpRightFromSquare} style={{ fontSize: '0.8rem' }} />
        </IconButton>
      )}
    </Box>
  </FieldRowStyled>
);
